import { Inject, Injectable } from '@angular/core';
import { IAnalyticsEvent } from '@services';
import { WINDOW } from '../window.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(@Inject(WINDOW) private window: Window) {}

  track(event: IAnalyticsEvent): void {
    (this.window as any).dataLayer.push({ event: event.name, ...event.data });
  }
}
